import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import FinalizarAprovacao from "model/documentos/fluxo/FinalizarAprovacao";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";

type Props = {
    visible: boolean;
    onHide: () => void;
    value: FinalizarAprovacao;
    onChange: (value: FinalizarAprovacao) => void;
    onConfirm: () => void;
}

export default function ModalDocumentoReprovar(props: Props) {

    const {  msgAlerta } = useToastContext();

    function handleConfirm() {
        if (!props.value.motivoReprovacao) {
            msgAlerta("Alerta", "Motivo de reprovação é obrigatório.");
            return;
        }
        props.onConfirm();
        props.onHide();
    }
    return (
        <Dialog
            header="Reprovar"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '500px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Fechar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Aceitar" icon="pi pi-check" onClick={() => handleConfirm()} />
            </>}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', paddingLeft: '12px', paddingRight: '12px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
                    <Label>Motivo da reprovação</Label>
                    <InputTextarea rows={3} value={props.value.motivoReprovacao || ""} onChange={(e) => {
                        props.onChange({ ...props.value, motivoReprovacao: e.target.value });
                    }} style={{ width: '100%' }} />
                </div>
            </div>
        </Dialog>
    );
}